import { render, staticRenderFns } from "./PropGrossEstimatePricingTable.vue?vue&type=template&id=fca6b7b4&scoped=true&"
import script from "./PropGrossEstimatePricingTable.vue?vue&type=script&lang=js&"
export * from "./PropGrossEstimatePricingTable.vue?vue&type=script&lang=js&"
import style0 from "./PropGrossEstimatePricingTable.vue?vue&type=style&index=0&id=fca6b7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca6b7b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDivider,VRow})
